// extracted by mini-css-extract-plugin
module.exports = {"cell":"PromotionBarSlidesTable_cell__2ti-o","actionHeader":"PromotionBarSlidesTable_actionHeader__GZzPV","contentCell":"PromotionBarSlidesTable_contentCell__2M9Zj"};